import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const Wrapper = styled(motion.section)`
  min-height: 100vh;
  width: 100%;
  padding: 4.5rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.bg || "var(--bg-main)"};
  color: ${(props) => props.color || "var(--text-main)"};
  text-align: center;

  @media (max-width: 768px) {
    padding: 3.5rem 1rem;
  }
`;

const Section = ({ children, bg, color }) => {
  return (
    <Wrapper
      bg={bg}
      color={color}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, ease: [0.2, 0.65, 0.3, 1] }}
      viewport={{ once: true, amount: 0.3 }}
    >
      {children}
    </Wrapper>
  );
};

export default Section;
